import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
import query from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes } from 'syf-component-library/defaultTheme';
import { Textfield } from 'syf-component-library/ui/atoms';
import { Label } from 'syf-component-library/ui/atoms/Textfield/subcomponents';
import { FAR_CIRCLE_EXCLAMATION } from '../../../../const/icon-props';
import Icon from '../../../icon';
export const TextWrapper = styled.span `
  display: inline-block;
  font-size: ${fontSizes.root}px;
`;
export const CustomTextField = styled(Textfield) `
  ${Label} {
    font-size: 14px;
    color: ${({ theme, error }) => error === '' ? theme.bodyText : colors.error};
    @media ${query.lessThanSmall} {
      display: inline-block;
      width: 90%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;
const ErrorWrapper = styled(Inset) `
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 1px;
`;
export const ErrorIcon = () => (_jsx(ErrorWrapper, { right: "xsmall", children: _jsx(Icon, { title: "circle error icon", color: colors.error, icon: FAR_CIRCLE_EXCLAMATION, size: "1x" }) }));
